<template>
    <section>
        <div v-show="showlist">
        <sy-baselist
                ref="list"
                :filters="filters"
                editVue="business/Vote_Edit.vue"
                listUrl="server/business/Vote.ashx?cmd=GetList"
                deleteUrl="server/business/Vote.ashx?cmd=Delete"
                :pageSize="20"
                DelTips="该投票相关的所有投票记录将会被同时删除，确定删除吗？"
        >
            <el-table-column prop="FName" label="投票名称" width="150">
            </el-table-column>
             <el-table-column prop="FCandidateNames" label="候选人" width="300">
            </el-table-column>
            <el-table-column prop="FStartTime" label="开始时间" :formatter="formatDate2" width="180" sortable>
            </el-table-column>
              <el-table-column prop="FEndTime" label="结束时间" :formatter="formatDate2" width="180" sortable>
            </el-table-column>
            <el-table-column prop="FNum" label="选择人数" width="80">
            </el-table-column>
              <el-table-column prop="FScore" label="积分" width="80">
            </el-table-column>
              <el-table-column prop="FIsSelReward" label="是否选中奖励" width="120" :formatter="formatReward">
            </el-table-column>
             <el-table-column prop="FResult" label="投票结果" width="300">
            </el-table-column>
            <el-table-column prop="FStatus" label="状态" width="100" :formatter="formatStatus">
            </el-table-column>
            <template scope="props" slot="extendbtn">
                <el-button size="mini" class="el-icon-view el-button el-button--text el-button--mini"  @click="showtrends(props.row)">投票情况</el-button>
            </template>
        </sy-baselist>
        </div>
            <div v-show="showtrend">
        <el-row>
            <el-col  class="toolbar">
                <el-form>
                    <el-form-item>
                        <el-tag  type="gray">{{joblist.length>0?joblist[0].FName:''}}</el-tag>
                        <a @click="showlists" style="color:#409EFF;margin-left: 20px;cursor:pointer;">&lt; 返回</a>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
            <template v-if="false">
                <el-table ref="table" :data="joblist">
                    <el-table-column prop="FName" label="投票名称" width="250" >
                    </el-table-column>  
                </el-table>
            </template>
        <el-row :gutter="20">
            <el-col :span="24">
                <sy-baselist
                        ref="protrends"
                        :autoSearch="false"
                        title="投票情况"
                        hideAdd
                        hideOperate
                        listUrl="server/business/Vote.ashx?cmd=GetRecordList"    
                >
                    <el-table-column prop="UserName" label="投票人"  width="100">
                    </el-table-column>
                    <el-table-column prop="CandidateName" label="候选人"  width="100">
                    </el-table-column>
                    <el-table-column prop="FCreateTime" label="投票时间" :formatter="formatDate2" width="180">
                    </el-table-column>
                    <el-table-column prop="FNote" label="备注" width="100">
                    </el-table-column>
                </sy-baselist>
            </el-col>
        </el-row>
        </div>
    </section>
</template>

<script>
     import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data(){
            return {
                jobID:0,
                jobRow:{},
                filters: [
                    {type: "string",name:"FName",text:"投票名称", value: null}
                ],
                showlist:true,
                showtrend:false,
                joblist:[]
            }
        },
        methods:{
            showtrends(row){
                this.jobID = row.FID
                this.jobRow =row
                this.showlist=false
                this.showtrend=true
                this.joblist=[]
                this.joblist.push(this.jobRow)
                this.$refs.protrends._search("","FVoteId="+this.jobID)
            },     
            showlists(){ 
             this.showtrend=false
             this.showlist=true
            },
             formatStatus(row){
                let status=""
                switch(row.FStatus){
                    case 0: {status='待开启'; break;}
                    case 1: {status='进行中'; break;}
                    case 1: {status='已结束'; break;}
                   
                }
                return status
            },
            formatReward(row){
                return row.FIsSelReward==1?'选中奖励':'选中不奖励'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Vote.vue